export default "/images/971788e52206e950ee1d292b01819421.png";